<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="จัดกลุ่มตามช่วงเวลา">
                <statistic-level-range-time></statistic-level-range-time>
            </TabPanel>
            <TabPanel header="เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี">
                <statistic-level-year></statistic-level-year>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import statisticLevelRangeTime from './StatisticLevelRangeTime';
import statisticLevelYear from './StatisticLevelYear';

export default {
    components: {
        statisticLevelRangeTime,
        statisticLevelYear
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>